import React, { Component } from 'react';
import { connect, ResolveThunks } from 'react-redux';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { deletePages, regenerateTdds } from '../../actions/documents';
import { getMetaPdfsAndComponentsAsSortedArrays } from '../../selectors/documents';
import { RootState } from '../../store';
import MaterialDocumentTree from '../MaterialDocumentTree/MaterialDocumentTree';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

interface State {
  readonly selectedPages: readonly number[];
}

class MoreOptionsDialog extends Component<Props, State> {
  state: State = {
    selectedPages: [],
  };

  onDeleteSelected = () => {
    this.props.deletePages(this.state.selectedPages);
    this.props.closeCurrentPopup();
  };

  onRegenerateSelectedTdds = () => {
    this.props.regenerateTdds(this.state.selectedPages);
    this.props.closeCurrentPopup();
  };

  onSelectedPagesChange = (selectedPages: readonly number[]) => {
    this.setState({ selectedPages });
  };

  render() {
    const { isParagonJob } = this.props;

    const otherButtons: { [buttonName: string]: { handler: () => void } } = {};
    otherButtons['Delete Selected'] = { handler: this.onDeleteSelected };
    if (isParagonJob) {
      otherButtons['Regenerate TDDs'] = { handler: this.onRegenerateSelectedTdds };
    }

    return (
      <Dialog title="More Options" otherButtons={otherButtons} onCancel="close" contentSx={{ p: 2 }}>
        <MaterialDocumentTree
          metaPdfs={this.props.metaPdfs}
          components={this.props.components}
          selectedPages={this.state.selectedPages}
          onSelectedPagesChange={this.onSelectedPagesChange}
        />
      </Dialog>
    );
  }
}

function mapStateToProps(state: RootState) {
  const [metaPdfs, components] = getMetaPdfsAndComponentsAsSortedArrays(state);
  const isParagonJob = state.job.designOrigin === 'Paragon';

  return { isParagonJob, metaPdfs, components };
}

const actionCreators = {
  closeCurrentPopup,
  deletePages,
  regenerateTdds,
};

export default connect(mapStateToProps, actionCreators)(MoreOptionsDialog);
